import * as React from 'react'

import LiveScore from '../../containers/LiveScore'
import PlayerAndOdds from '../../containers/PlayerAndOdds'

import('./MatchListOddsStyles.scss')   



// set class if quick betting is activated in gui
const isQuickBettingOn = ( expanded : boolean) => {
  return expanded === true ? 'quickBettingActive' : '';
}

// set class if match is in currently selected channel
const isMatchGroupActive = ( activeChannelId: number, index: number ) => {
  return activeChannelId === index ? 'matchGroupActive' : ''
}


const MatchListOddsPresentation = ( props : { timings: any[], quickBetsState?: any, activeChannelId: number } ) => {
  // render a combination of livescore and odds for each channel
  return (
      <div className={"matchGroupsContainer matchListOdds " + isQuickBettingOn(props.quickBetsState)}>
        {props.timings.map((timing:any = {}, index: number ) =>
        <div className={"matchGroupContainer " +  isMatchGroupActive(props.activeChannelId, (index+1))} key={"matchGroup_"+timing.id}>
          <div className="matchGroupLivescore">
            <LiveScore  key={`livescore-${timing.id}`}
                        channelId = { timing.id } />
          </div>
          <PlayerAndOdds  key={`playerAndOdds-${timing.id}`}
                          channelId = { timing.id } />
        </div>
            )}
      </div>
  )
};

export default MatchListOddsPresentation;
